<lib-sidenav-wrapper (closePanel)="closeSideNav()">
    <lib-nav-links [groups]="navGroups"></lib-nav-links>
</lib-sidenav-wrapper>
